import { render, staticRenderFns } from "./ModalRecommendMob.vue?vue&type=template&id=4309ce27&scoped=true&"
import script from "./ModalRecommendMob.vue?vue&type=script&lang=js&"
export * from "./ModalRecommendMob.vue?vue&type=script&lang=js&"
import style0 from "./ModalRecommendMob.vue?vue&type=style&index=0&id=4309ce27&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4309ce27",
  null
  
)

export default component.exports